import config from "../config/app.conf.json";

export default (entityuId, type) => ({
  url: `${config.api.permissions_service_url}/organizations/${entityuId}/users?type=${type}`,
  method: "GET"
});